<template>
  <card style="box-shadow:none">
    <div slot="header">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div>
      <form>
        <div class="row">
          <div class="col-xl-3 form-row-top">
            <div class="row">
              <div class="col-xl">
                <div class="edit-logo-box">
                  <div>Logo:</div>
                  <div style="margin-bottom: 10px;">
                    <img
                      :src="company.logo_url || 'static/img/generic-logo.png'"
                      style="width: 162px;"
                    />
                  </div>
                  <div>
                    <input
                      v-model="company.logo_url"
                      class="url-form-field"
                      style="width: 100%;margin-bottom: 20px;"
                      placeholder="Url to image..."
                      v-on:change="valueChanged()"
                    />
                  </div>
                  <div v-if="!diligence">
                    <div>Contact Email:</div>
                    <input
                      type="text"
                      v-model="company.contact_email"
                      class="url-form-field"
                      style="width: 100%;"
                      placeholder="Contact Email"
                      v-on:change="valueChanged()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-9">
            <div class="row">
              <div class="col-xl form-row-top">
                <div>
                  Company Name:
                  <span class="required">*</span>
                </div>
                <fg-input
                  type="text"
                  v-if="company._id"
                  placeholder="Enter company (unique) name..."
                  v-model="company.name"
                  v-on:change="valueChanged()"
                ></fg-input>
                <autocomplete
                  v-if="!company._id"
                  ref="autocomplete"
                  placeholder="Enter company (unique) name..."
                  :resultsFormatter="resultsFormatter"
                  :source="autocompleteCompanyEndPoint"
                  input-class="form-control"
                  results-property="data.items"
                  :initialDisplay="company.name"
                  :results-display="formattedDisplay"
                  @selected="onAfterCompanySelection"
                  :resultsDisplay="resultsDisplay"
                ></autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 form-row-top">
                <div>
                  Sector:
                  <!-- <span class="required">*</span> -->
                </div>

                <!-- here -->

                <vue-single-select
                  v-model="company.sector"
                  placeholder="Select Sector"
                  :options="vals.SECTOR_DEFINES"
                  class="form-control form-control-dd"
                  v-on:input="valueChanged()"
                ></vue-single-select>
              </div>
              <div class="col-xl-3 form-row-top">
                <div>Geography:</div>
                <input
                  type="text"
                  v-model="company.geography"
                  class="select-primary form-control form-control-dd pl-2"
                  id="autocompleteMap"
                />
                <input type="hidden" name="lat" />
                <input type="hidden" name="long" />
              </div>
              <div class="col-xl-3 form-row-top">
                <div>Current Stage:</div>
                <el-select
                  class
                  size="large"
                  placeholder="Select Stage"
                  v-model="company.stage"
                  v-on:change="valueChanged()"
                >
                  <el-option
                    v-for="option in vals.STAGE_DEFINES"
                    class
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-xl-3 form-row-top">
                <div>Status:</div>
                <el-select
                  class
                  size="large"
                  placeholder="Select Status"
                  v-model="company.status"
                  v-on:change="valueChanged()"
                >
                  <el-option
                    v-for="option in vals.STATUS_DEFINES"
                    class
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
                <div></div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 form-row-top">
                <div>Founding Date:</div>
                <input type="date" class="form-control" v-model="company.founding_date" />
              </div>
              <div class="col-xl-4 form-row-top">
                <div>Est. Revenue Range:</div>
                <input type="text" class="form-control" v-model="company.estimated_revenue_range" />
              </div>
              <div class="col-xl-4 form-row-top">
                <div :dummy="ratingRefresh">Rating:</div>
                <div class="star-rating mt-2">
                  <i
                    class="fa fa-star"
                    @click="changeRating(1)"
                    aria-hidden="true"
                    v-if="company.rating >= 1"
                  ></i>
                  <i
                    class="fa fa-star-o"
                    @click="changeRating(1)"
                    aria-hidden="true"
                    v-if="company.rating < 1"
                  ></i>
                  <i
                    class="fa fa-star"
                    @click="changeRating(2)"
                    aria-hidden="true"
                    v-if="company.rating >= 2"
                  ></i>
                  <i
                    class="fa fa-star-o"
                    @click="changeRating(2)"
                    aria-hidden="true"
                    v-if="company.rating < 2"
                  ></i>
                  <i
                    class="fa fa-star"
                    @click="changeRating(3)"
                    aria-hidden="true"
                    v-if="company.rating >= 3"
                  ></i>
                  <i
                    class="fa fa-star-o"
                    @click="changeRating(3)"
                    aria-hidden="true"
                    v-if="company.rating < 3"
                  ></i>
                  <i
                    class="fa fa-star"
                    @click="changeRating(4)"
                    aria-hidden="true"
                    v-if="company.rating >= 4"
                  ></i>
                  <i
                    class="fa fa-star-o"
                    @click="changeRating(4)"
                    aria-hidden="true"
                    v-if="company.rating < 4"
                  ></i>
                  <i
                    class="fa fa-star"
                    @click="changeRating(5)"
                    aria-hidden="true"
                    v-if="company.rating >= 5"
                  ></i>
                  <i
                    class="fa fa-star-o"
                    @click="changeRating(5)"
                    aria-hidden="true"
                    v-if="company.rating < 5"
                  ></i>
                  <!-- <i class="fa fa-star fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star-o fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star-o fa-lg"
                      aria-hidden="true"></i>
                    <i class="fa fa-star-o fa-lg"
                  aria-hidden="true"></i>-->
                </div>
              </div>
            </div>
            <div class="row" v-if="diligence">
              <div class="col-xl-4 form-row-top">
                <div>Deal Stage:</div>
                <el-select
                  class
                  size="large"
                  placeholder="Select Stage"
                  v-model="company.deal_stage"
                  v-on:change="valueChanged()"
                >
                  <el-option
                    v-for="option in diligenceStageData"
                    class
                    :value="option._id"
                    :label="option.stage_name"
                    :key="option._id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-xl-4 form-row-top">
                <div>Referred By:</div>
                <tags-input
                  element-id="tags"
                  v-model="company.referred_by"
                  typeahead-style="dropdown"
                  @change="onChange"
                  placeholder="Referred By"
                  :existing-tags="existingRefers"
                  :typeahead-max-results="typeMaxResults"
                  :case-sensitive-tags="caseSensitiveTags"
                  :typeahead="true"
                ></tags-input>
              </div>
              <div class="col-xl-4 form-row-top">
                <div>Contact Email:</div>
                <input
                  type="text"
                  v-model="company.contact_email"
                  class="url-form-field"
                  style="width: 100%;"
                  placeholder="Contact Email"
                  v-on:change="valueChanged()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl form-row-top">
            <span class="required">* Indicates a required field</span>
          </div>
        </div>
        <!-- <div class="text-center"> -->
        <!-- <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="update">
        Update Profile
        </button>
        <button type="submit" class="btn btn-info btn-fill btn-wd">
        Clear My Data
        </button>-->
        <!-- </div> -->
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import Card from "../Card.vue";
import { vals } from "../../../util";
import { Select, Option } from "element-ui";
import _ from "lodash";
import Autocomplete from "vuejs-auto-complete-with-abort";
import TagsInput from "@voerro/vue-tagsinput";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";

import VueSingleSelect from "vue-single-select";

export default {
  name: "company-edit-card",
  computed: {
    ...mapGetters("diligence_stage", ["diligenceStageData"])
  },
  components: {
    Autocomplete,
    VueSingleSelect,
    TagsInput,
    Card,
    [Option.name]: Option,
    [Select.name]: Select
  },
  data() {
    return {
      vals,
      ratingRefresh: 0,
      existingRefers: [],
      caseSensitiveTags: false,
      typeMaxResults: 5
    };
  },
  props: {
    title: {
      type: String
    },
    diligence: {
      type: String
    },
    company: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    valueChanged() {
      this.$emit("card-onchange");
    },
    onChange(value) {
      let self = this;
      api
        .get(`/attributors/${self.$route.params.workspace_id}/${value}`)
        .then(data => {
          self.existingRefers = [];
          data.data.encrypt.data.map(item => {
            let json = {};
            json.key = item._id;
            json.value = item.name;
            self.existingRefers.push(json);
          });
        })
        .catch(err => {
          console.log("error", err);
        });
    },
    changeRating(rating) {
      this.company.rating = rating;
      this.ratingRefresh++;
    },
    geographyData() {
      return this.$store.getters["company/geographyData"];
    },
    autocompleteCompanyEndPoint(input) {
      return `${CRUNCHBASE_BASE_URL}odm-organizations?user_key=${CRUNCHBASE_USER_KEY}&query=${input}`;
    },
    resultsFormatter(input) {
      return input.data.items.map(item => {
        return { id: item.uuid, name: item.properties.name, raw: item };
      });
    },
    onAfterCompanySelection(selectedValue) {
      // this.company.name = selectedValue.selectedObject.name;
      // this.$refs.autocomplete.clear();
      let self = this;
      setTimeout(() => {
        self.$refs.autocomplete.display = selectedValue.selectedObject.name;
        self.company.name = selectedValue.selectedObject.name;

        self.company.website =
          selectedValue.selectedObject.raw.properties.homepage_url;
        self.company.facebook =
          selectedValue.selectedObject.raw.properties.facebook_url;
        self.company.linkedin =
          selectedValue.selectedObject.raw.properties.linkedin_url;
        self.company.twitter =
          selectedValue.selectedObject.raw.properties.twitter_url;
        self.company.logo_url =
          selectedValue.selectedObject.raw.properties.profile_image_url;
        self.company.permalink =
          selectedValue.selectedObject.raw.properties.permalink;
        self.company.cb_data = selectedValue.selectedObject.raw;

        self.valueChanged();
      }, 10);
    },
    formattedDisplay(result) {
      return result.name;
    },
    resultsDisplay(result) {
      let companies = this.$store.getters["portfolio/portfolioData"];

      let found = _.find(companies, function(item) {
        return item.permalink == result.raw.properties.permalink;
      });

      return `<div class="${found ? "duplicate" : ""}">
        <div class=" dd-icon-wrapper">
        <img class="dd-icon" src="${result.raw.properties.profile_image_url}">
        </div>
        ${result.name}
        <span class="gray">${result.raw.properties.short_description}</span>
        <span class="exists">already exists in your portfolio</span>
        </div>`;
    }
  },
  mounted() {
    if (_.isNil(this.company.rating)) this.company.rating = 0;
    this.ratingRefresh++;
    setTimeout(() => {
      let input = document.getElementById("autocompleteMap");
      let autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["(cities)"]
      });
      google.maps.event.addListener(autocomplete, "place_changed", () => {
        let place = autocomplete.getPlace();
        this.company.geography = place.formatted_address
          ? place.formatted_address
          : place.name;
      });
    }, 2000);
  },
  watch: {
    company(newData) {
      if (_.isNil(this.company.rating)) this.company.rating = 0;
    }
  }
};
</script>
<style lang="scss">
.required {
  color: red;
}
.pac-container {
  z-index: 100000;
}

.form-control.form-control-dd {
  border: 1px solid #707070;
  margin: 0;
  padding: 0;
  .search-input {
    height: 38px;
  }
}
.form-control {
  border: 1px solid #868686;
  margin-top: 4px;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.form-group {
  margin-bottom: auto;
}

.select-primary.el-select .el-input input {
  width: 100%;
  margin-top: 4px;
  margin-bottom: 10px;
}

.form-row-top {
  margin-top: 10px;
}

.star-rating {
  color: #707070;
  margin-bottom: 20px;
}

.star-rating i {
  margin-right: 4px;
  cursor: pointer;
}

.gray {
  font-size: 14px;
  // color: #ababab;
  font-style: italic;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  display: inline-block;
  margin-top: 5px;
  line-height: 12px;
}
.autocomplete__icon {
  height: 14px;
  width: 14px;
  line-height: 9px;
}
.autocomplete__inputs {
  input {
    margin: 0;
  }
}

.autocomplete__box {
  border-color: #707070;
  .form-control:focus {
    border: none;
    outline: none;
  }
}

.dd-icon-wrapper {
  width: 30px;
  height: 30px;
  display: inline-block;
}
.dd-icon {
  max-width: 100%;
  max-height: 100%;
}

.exists {
  display: none;
  font-size: 12px;
  position: absolute;
  right: 13px;
  top: 8px;
  background-color: green;
  padding: 2px 7px;
  border-radius: 20px;
  color: #fff;
}
.duplicate {
  .exists {
    display: block;
  }
}

li.autocomplete__results__item:nth-child(even) {
  background: #f9f9f9;
}
.typeahead-dropdown {
  box-shadow: 0px 3px 3px #00000050 !important;
}

.typeahead-dropdown li {
  padding: 0.25em 1em;
  cursor: pointer;
  color: gray;
  background: white;
}

.tags-input-typeahead-item-highlighted-default {
  color: #fff !important;
  background-color: #007bff !important;
}
.tags-input-wrapper-default {
  border: 1px solid #707070;
}
</style>
